import PhotoCropModal from './modal';

export default PhotoCropModal;
